import React, { useEffect } from 'react';
import {
	createBrowserRouter,
	RouterProvider,
} from 'react-router-dom';

import App from './App';
import StreamsTokenLogin from './components/streams-token-login';
import CreateGreenroomFromStreamsSession from './components/create-greenroom-from-streams-session';
import LandingPage from './components/landing-page/landing-page';
import { LANDING_PAGE_TYPES } from './types/constants';
import IconPreviews from './components/general-components/icon-previews';
import OAuth from './components/redirect/oauth';
import blAuthLoader from './loaders/bl-auth';

export default function Router() {
	/**
	 * this fixes a bug in react where process is not defined in non-react components
	 */
	useEffect(() => {
		window.process = {
			...window.process,
		};
	}, []);

	const router = createBrowserRouter([
		{
			path: '/login-with-streams-token/:token',
			element: <StreamsTokenLogin />,
			errorElement: <LandingPage type={LANDING_PAGE_TYPES.UNHANDLED_THROWN_ERROR} />,
		},
		{
			path: '/create/:sessionId',
			element: <CreateGreenroomFromStreamsSession />,
			errorElement: <LandingPage type={LANDING_PAGE_TYPES.UNHANDLED_THROWN_ERROR} />,
			loader: blAuthLoader,
		},
		{
			path: '/icons/preview',
			element: (
				<>
					{(
						document.location.hostname.includes('localhost') 
						|| document.location.hostname.includes('dev')
						|| document.location.hostname.includes('qa')
					) && (
						<IconPreviews />
					)}
				</>
			),
			errorElement: <LandingPage type={LANDING_PAGE_TYPES.UNHANDLED_THROWN_ERROR} />,
		},
		// Background on the 2 oauth routes: https://github.com/remix-run/react-router/issues/7285
		{
			path: '/oauth/:roomId',
			element: <OAuth />,
			errorElement: <LandingPage type={LANDING_PAGE_TYPES.UNHANDLED_THROWN_ERROR} />,
		},
		{
			path: '/oauth/',
			element: <OAuth />,
			errorElement: <LandingPage type={LANDING_PAGE_TYPES.UNHANDLED_THROWN_ERROR} />,
		},
		{
			path: '/*',
			element: <App />,
			errorElement: <LandingPage type={LANDING_PAGE_TYPES.UNHANDLED_THROWN_ERROR} />,
		},
	]);

	return (
        <>
            <RouterProvider router={router} />
        </>
	);
}
